// import React from "react";
import React, { useState, useEffect, useRef } from 'react';
import styles from './ObjectItemSlider.module.scss';
import Slider from 'react-slick';
// import SliderObjects from "../../../../../universal_components/SliderObjects/SliderObjects";
// import { isMobile } from 'react-device-detect';
// import DeskctopImageList from './DeskctopImageList';

const ObjectItemSlider = ({ item, video_link, openFullScreenImg }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [isDragging, setIsDragging] = useState(false); // Флаг для отслеживания свайпа
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  const handleBeforeChange = () => {
    setIsDragging(true); // Устанавливаем флаг при начале свайпа
  };

  const handleAfterChange = () => {
    setTimeout(() => setIsDragging(false), 100); // Сбрасываем флаг после свайпа
  };

  return (
    <div className={styles.slider} id="objectSlider">
      <Slider
        asNavFor={nav2}
        ref={(slider) => (sliderRef1 = slider)}
        beforeChange={handleBeforeChange}
        afterChange={handleAfterChange}>
        {item.map((img) => (
          <div
            key={img.id}
            className={styles.mainImage}
            open={openFullScreenImg}
            onClick={(e) => {
              if (isDragging) {
                e.preventDefault();
                return;
              }
              openFullScreenImg(img.photo);
            }}>
            <img src={img.thumbnails.middle} alt="" />
          </div>
        ))}
      </Slider>

      <Slider
        asNavFor={nav1}
        ref={(slider) => (sliderRef2 = slider)}
        slidesToShow={3}
        swipeToSlide={true}
        infinite={item.length > 3}
        focusOnSelect={true}>
        {item.map((img) => (
          <div key={img.id} className={styles.miniImage}>
            <img src={img.thumbnails.middle} alt="" />
          </div>
        ))}
      </Slider>
      {/* {isMobile ? (
        // <SliderObjects item={item} openFullScreenImg={openFullScreenImg} />
        <DeskctopImageList item={item} open={openFullScreenImg} />
      ) : (
        <DeskctopImageList item={item} open={openFullScreenImg} />
      )} */}
    </div>
  );
};

export default ObjectItemSlider;
